<div>
  <span *ngFor="let item of colorThemes"
  class="theme-bubble theme-bubble--{{item}}"
  (click)="switchColorTheme(item)"></span>
</div>